module.exports = {
  _name: "tests",
  _prio: 0,
  _v: 1,
  _mergers: [
    {
      source: "tests",
      setup: function() {
        return {
          iterate: function() {}
        };
      },
      finisher: function(obj) {
        var base;
        if (process.env.NODE_ENV === "test") {
          if (window.ceri == null) {
            window.ceri = {};
          }
          if ((base = window.ceri).tests == null) {
            base.tests = [];
          }
          return window.ceri.tests.push(obj);
        }
      }
    }
  ],
  created: function() {
    if (process.env.NODE_ENV === "test") {
      return this.$nextTick(function() {
        return typeof this.tests === "function" ? this.tests(this) : void 0;
      });
    }
  }
};

;



//////////////////
// WEBPACK FOOTER
// /home/peaul/ceri/ceri/lib/tests.js
// module id = 73
// module chunks = 1